export enum TipoDeImposto {
  IVA_5 = 'IVA_5',
  IVA_10 = 'IVA_10',
  IVA_ISENTO = 'IVA_ISENTO',
}
